import React, {Dispatch, FC, SetStateAction} from "react";
import {v4 as uuidV4} from "uuid";
import {configVariablesIfRLookUp, replacerLookUpResponseObjectInToFormConfig} from "./functions";
import FormInputTypes from "../../Components/UI/FormInputType/index"; // Adjust the path based on your project structure

interface RenderInputProps {
  row: {
    type: string;
    title: string;
    required: boolean;
    errorMessage?: string;
    value?: string;
    options?: string[];
    id?: string;
    placeholder?: string;
    maxLength?: number;
  };
  index: number;
  myData: {
    formConfig: any[]; // Update with the actual type
  };
  setMyData: Dispatch<SetStateAction<{ formConfig: any[]; reload: string }>>;
}

interface ComponentType {
  [key: string]: FC<any>;
}

export const COMPONENT_TYPE: ComponentType = {
  // Assuming FormInputTypes contains the components
  "string": FormInputTypes.StingType,
  "number": FormInputTypes.NumberType,
  "longNumber": FormInputTypes.LongNumberType,
  "longNumber+2float": FormInputTypes.LongNumber_2floatType,
  "smallNumber": FormInputTypes.SmallNumberType,
  "smallFloat": FormInputTypes.SmallFloatType,
  "longFloat": FormInputTypes.LongFloatType,
  "date": FormInputTypes.DateType,
  "time": FormInputTypes.TimeType,
  "mobile": FormInputTypes.MobileType,
  "telephone": FormInputTypes.TelephoneType,
  "email": FormInputTypes.EmailType,
  "price": FormInputTypes.PriceType,
  "color": FormInputTypes.ColorType,
  "year": FormInputTypes.YearType,
  "month": FormInputTypes.MonthType,
  "day": FormInputTypes.DayType,
  "selectBox": FormInputTypes.SelectBoxType,
  "cashBox": FormInputTypes.CashBoxType,
  "rlookup": FormInputTypes.RLookupType,
  "file": FormInputTypes.FileType,
  "textarea": FormInputTypes.TextareaType,//
  "computed": FormInputTypes.Computed,//
  "editor": FormInputTypes.Editor,//
  // اگه در آینده بک اند تایپ جدیدی اضفه کرد باید اینجا اضفه کنیم و کامپوننت خودشو اضافه کنیم
};

const RenderInput: FC<RenderInputProps> = ({row, index, myData, setMyData}) => {

  const changeValueHandler = (index: number, myKey: string, value: string) => {
    const formConfig = [...myData.formConfig];
    formConfig[index][myKey] = value;
    const reload = uuidV4();
    setMyData({formConfig, reload});
  };

  const onblurHandler = (index: number, row: any) => {
    const formConfig = [...myData.formConfig];
    let message = '';
    if (row.required && !row.value) {
      message = `${row.title} نباید خالی باشد`;
    }
    formConfig[index]['errorMessage'] = message;
    const reload = uuidV4();
    setMyData({formConfig, reload});
  };

  const rLookUpResponse = (rLookUpResponseObject: Record<string, any>) => {
    const temp = [...myData.formConfig];
    let formConfig: any;
    formConfig = replacerLookUpResponseObjectInToFormConfig(temp, rLookUpResponseObject);

    // بک اومد توی ریسپانس آرلوکاپ این کلید رو اضافه کرد و گفت توی آرلوکاپ نشون بده
    formConfig[index]['buttonCaption'] = rLookUpResponseObject['buttonCaption']

    setMyData({formConfig, reload: uuidV4()});
    // changeValueHandler(index,"buttonCaption",rLookUpResponseObject?.rLookUpResponseObject)
    onblurHandler(index, row);

  };

  const {type, title, required, maxLength} = row;

  const ComponentShow = COMPONENT_TYPE[type];
  const awesomeChanger = (value: string) => {
    changeValueHandler(index, "value", value);
  };

  const variableValue = configVariablesIfRLookUp({row, myData});
  const ComponentToShow = COMPONENT_TYPE[type];
  // یک حالتی که داریم اینه که  مقدار باید حساب بشه.
  if (row.type === 'computed') {

    try {
      const temp = row['formula']?.map(formula => {
        const type = formula.type;
        let value = formula.value;
        let t = value
        if (type === 'field') {
          t = myData?.formConfig?.filter(row => row.name===value)[0]['value']

        }
        if (t) {
          return t
        } else {
          return ''
        }
      })


      const compute = temp.join('')
      const result = eval(compute);
      row.value = result
    } catch (error) {
      row.value = ''
    }
  }

  return ComponentToShow ? (<ComponentShow
    id={index}
    row={row}
    myData={myData}
    onChange={awesomeChanger}
    onBlur={() => onblurHandler(index, row)}
    functionAfterSelect={rLookUpResponse}
    variables={Object.keys(variableValue).length === 0 ? undefined : JSON.stringify(variableValue)}
  />) : (<input value={"تایپ ورودی در برنامه تعریف نشده!"} disabled={true}/>);
};

export default React.memo(RenderInput);
